import SliderShoeHero from "./SliderShoeHero.component";

export default SliderShoeHero;
